export default "__VITE_ASSET__ByhYLd6k__"